module.exports = __webpack_public_path__ + "static/media/hero_mobile.f7aa6bd4.webp";